<template>
    <Modalog
        :has-header="false"
        :has-inline-errors="true"
        contentClass="dialog__content--has-media"
        size="large"
        :transition-name="transitionName"
    >
        <template #content>
            <div class="content-media">
                <div class="content-media__image">
                    <div class="add-item-media__upload">
                        <image-upload
                            ref="dropzoneRef"
                            v-on:image-added="imageAdded"
                            v-on:image-uploaded="imageUploaded"
                        />
                    </div>
                </div>
            </div>
            <div class="content-main">
                <!--Errors the fields below don't display inline-->
                <div class="content-errors" v-if="summaryErrors.length">
                    <Errors
                        class-modifier="error--wide error--margin-bottom"
                        :passed-errors="summaryErrors"
                    />
                </div>
                <div
                    class="dialog__content--row"
                    :class="{ 'is-error': form.errors.name }"
                >
                    <!--Item name-->
                    <label class="form-label" for="item-name">Gift Name</label>
                    <input
                        class="input"
                        type="text"
                        id="item-name"
                        name="item-name"
                        placeholder="Our Wedding Day"
                        required
                        maxlength="255"
                        v-model="form.name"
                        autocomplete="off"
                    />
                </div>
                <!--Name validation errors-->
                <div
                    class="dialog__content--row dialog__content--row-no-padding is-error"
                    v-if="form.errors.name"
                >
                    <div class="form-control__response">
                        {{ form.errors.name }}
                    </div>
                </div>
                <!--Item URL-->
                <div
                    class="dialog__content--row"
                    :class="{ 'is-error': form.errors.url }"
                >
                    <label class="form-label is-optional" for="item-url"
                        >Link</label
                    >
                    <input
                        class="input"
                        type="text"
                        id="item-url"
                        name="item-url"
                        placeholder="https://www.coachella.com/guidebook/passes"
                        required
                        v-model="form.url"
                        autocomplete="off"
                    />
                </div>
                <!--URL validation errors-->
                <div
                    class="dialog__content--row dialog__content--row-no-padding is-error"
                    v-if="form.errors.url"
                >
                    <div class="form-control__response">
                        {{ form.errors.url }}
                    </div>
                </div>
                <!--Item Price / Currency / Quantity-->
                <div
                    class="dialog__content--row dialog__columns dialog__columns--two-thirds"
                >
                    <!--Price / Currency-->
                    <div class="column">
                        <div class="dialog__columns dialog__columns--two">
                            <!--Item price-->
                            <div class="column">
                                <label class="form-label" for="item-price"
                                    >Price</label
                                >
                                <div
                                    class="input-group"
                                    :class="{
                                        'is-error':
                                            invalidPrice || form.errors.price,
                                    }"
                                >
                                    <div class="input-group-prepend">
                                        <span class="input-group__text">{{
                                            $page.props.currencies[
                                                currencyCodeSelected
                                            ]
                                        }}</span>
                                    </div>
                                    <input
                                        type="number"
                                        class="input"
                                        id="item-price"
                                        name="item-price"
                                        required
                                        pattern="[0-9]+(\.[0-9][0-9]?)?"
                                        min="0"
                                        step="any"
                                        v-model="form.price"
                                        @input="validatePrice"
                                        autocomplete="off"
                                    />
                                </div>
                            </div>
                            <div class="column column--align-bottom">
                                <user-currency-select
                                    :currency-code="currencyCodeSelected"
                                    @currency-code-selected="
                                        setSelectedCurrency
                                    "
                                ></user-currency-select>
                            </div>
                        </div>
                    </div>
                    <!--Quantity-->
                    <div
                        class="column"
                        :class="{ 'is-error': form.errors.qty_desired }"
                    >
                        <template v-if="!isExpertList">
                            <label class="form-label" for="item-quantity"
                                >Qty</label
                            >
                            <input
                                class="input"
                                type="number"
                                id="item-quantity"
                                name="item-quantity"
                                defaultValue="1"
                                min="1"
                                max="500"
                                pattern="\d*"
                                required
                                v-model="form.qty_desired"
                                autocomplete="off"
                            />
                        </template>
                    </div>
                </div>
                <!--Default currency selector-->
                <!--<default-currency-inline-modalog :currency-code="selectedCurrency.code" :currency-symbol="selectedCurrency.symbol" v-show="hasInlineModalog"></default-currency-inline-modalog>-->
                <!--Price Errors-->
                <div
                    class="dialog__content--row dialog__content--row-no-padding is-error"
                    v-if="invalidPrice"
                >
                    <div class="form-control__response">
                        Price can only contain numbers and a single period.
                    </div>
                </div>
                <div
                    class="dialog__content--row dialog__content--row-no-padding is-error"
                    v-else-if="form.errors.price"
                >
                    <div class="form-control__response">
                        {{ form.errors.price }}
                    </div>
                </div>
                <!--Quantity Errors-->
                <div
                    class="dialog__content--row dialog__content--row-no-padding is-error"
                    v-if="form.errors.qty_desired"
                >
                    <div class="form-control__response">
                        {{ form.errors.qty_desired }}
                    </div>
                </div>
                <!--Item details-->
                <div class="dialog__content--row">
                    <label class="form-label is-optional" for="item-comments"
                        >Gift Details</label
                    >
                    <textarea
                        class="textarea"
                        name="item-comments"
                        placeholder="General Admission would be great!"
                        rows="2"
                        v-model="form.notes"
                        autocomplete="off"
                    ></textarea>
                </div>
            </div>
        </template>
        <template #footer>
            <button
                class="strip-btn dialog__action-button"
                @click="cancel"
                v-if="!isSaving"
            >
                Cancel
            </button>
            <throbber v-if="isSaving"></throbber>
            <button
                class="strip-btn dialog__action-button dialog__action-button--primary"
                :disabled="!validData"
                @click="uploadAndSave"
                v-if="!isSaving"
            >
                Save
            </button>
        </template>
    </Modalog>
</template>
<script setup>
import { computed, onBeforeUpdate, onMounted, ref, watch } from "vue";
import { useForm, usePage } from "@inertiajs/vue3";
import { debounce } from "lodash";
// import DefaultCurrencyInlineModalog from '../../modalogs/DefaultCurrencyInlineModalog';
import Errors from "@/Components/Errors/Errors.vue";
import ImageUpload from "@/Components/Actions/ImageUpload.vue";
import Modalog from "@/Components/Modalogs/Modalog.vue";
import Regex from "@/utilities/regex";
import Throbber from "@/Components/Throbber/Throbber.vue";
import UserCurrencySelect from "@/Components/forms/UserCurrencySelect.vue";
import { useModalogStore } from "@/stores/modalog";
import validUrl from "valid-url";
import { useImageUpload } from "@/composables/useImageUpload";

/* Fields that render their own message below the input, so they're kept out of the summary block. */
const INLINE_ERROR_FIELDS = ["name", "price", "qty_desired", "url"];

//--- Composables
const {
    cancel,
    dropzoneRef,
    fetchUploadSignature,
    file,
    imageAdded,
    imageUploaded,
    resetDropzone,
    uploadImage,
} = useImageUpload();

//--- Stores
const modalogStore = useModalogStore();

//--- Props
const props = defineProps(["custom", "listType", "listUuid"]);

//--- State
const currencyCodeSelected = ref(
    usePage().props?.auth.user.data.preferred_currency ?? "USD",
);
const isUploading = ref(false);
const isValidPrice = ref(true);
const thumbnailHeight = ref(100);
const thumbnailWidth = ref(100);
const transitionName = ref(null);
const useCustomDzOptions = ref(true);

//--- Form
const form = useForm({
    currency_code: currencyCodeSelected.value,
    list_uuid: props.custom.value.list_uuid,
    name: props.custom.value.name ?? "",
    notes: props.custom.value.notes ?? "",
    // Must be null, not "", so the server falls back to the default product photo.
    photo_uuid: props.custom.value.photo_uuid || null,
    price: props.custom.value.price ?? "0.00",
    qty_desired: props.custom.value.qty_desired ?? 1,
    url: props.custom.value.url ?? "",
});

/* Drop a field's message as soon as the user edits it, so it can't sit under a corrected value. */
INLINE_ERROR_FIELDS.forEach((field) => {
    watch(
        () => form[field],
        () => form.clearErrors(field),
    );
});

onMounted(async () => {
    await fetchUploadSignature("custom_gift_photo");
    transitionName.value = "fade";
});

onBeforeUpdate(async () => {
    await fetchUploadSignature("custom_gift_photo");
});

//--- Computed
const defaultCurrency = computed(() => {
    return "USD";
});

/**
 * Anything the server rejected that no field renders inline, so a new rule can never
 * fail silently.
 */
const summaryErrors = computed(() => {
    return Object.keys(form.errors)
        .filter((field) => !INLINE_ERROR_FIELDS.includes(field))
        .map((field) => form.errors[field]);
});

const isSaving = computed(() => {
    return isUploading.value || form.processing;
});

// TODO: This is the inline modalog to save as your default currency when changing the value in the dropdown.
const hasInlineModalog = computed(() => {
    return false;
    // return this.$store.state.modalogs.hasInlineModalog;
});

const invalidPrice = computed(() => {
    return !isValidPrice.value;
});

const isExpertList = computed(() => {
    return props.listType === "expert";
});

const isMobile = computed(() => {
    return false;
    return this.$store.state.isMobile;
});

const quantities = computed(() => {
    let data = [];

    for (let i = 1; i < 100; i++) {
        data.push(i);
    }

    return data;
});

const userPreferredCurrencyCode = computed(() => {
    return usePage().props?.auth.user.data.preferred_currency || "USD";
});

const validData = computed(() => {
    return form.name.length > 0 && form.qty_desired > 0 && isValidPrice.value;
});

const validOptionalUrl = computed(() => {
    return (form.url.length && validUrl.isUri(form.url)) || !form.url.length > 0
        ? true
        : false;
});

//--- Methods

function addItem() {
    form.currency_code = currencyCodeSelected.value;

    // The server redirects back, so Inertia swaps in the page with the new item.
    form.post(route("item.store.custom"), {
        preserveScroll: true,
        onSuccess: () => {
            modalogStore.closeModalog();
        },
    });
}

function setSelectedCurrency(currencyCode) {
    currencyCodeSelected.value = currencyCode;
}

/**
 * The photo lives on Cloudinary, not in the form payload, so it has to finish
 * uploading and set `photo_uuid` before the item itself is posted.
 */
const uploadAndSave = async () => {
    if (file.value) {
        isUploading.value = true;

        try {
            const responseData = await uploadImage();
            form.photo_uuid = responseData.public_id;
        } catch (error) {
            console.error(error);
        } finally {
            isUploading.value = false;
        }
    }

    addItem();
};

const validatePrice = debounce(function () {
    // See `/_js/utils/regex.js`
    isValidPrice.value = form.price.toString().search(Regex.priceInputs) >= 0; // Had to use `toString` in Vue 3
}, 500);

// TODO: Error handling
// export default {
//     watch: {
//         errors: function(errors) {
//             if (typeof errors !== 'object') {
//                 return false
//             }
//
//             // Scroll the container to the top
//             let container = document.getElementsByClassName('dialog__content')
//             if (container.length) {
//                 container.item(0).scrollTop = 0;
//             }
//         },
//         selectedCurrency (selectedCurrency) {
//             this.$store.commit('hasInlineModalog', true)
//         }
//     }
// }
</script>
